import { render, staticRenderFns } from "./doyan-phone.vue?vue&type=template&id=0f497b99&scoped=true"
import script from "./doyan-phone.vue?vue&type=script&lang=ts"
export * from "./doyan-phone.vue?vue&type=script&lang=ts"
import style0 from "./doyan-phone.vue?vue&type=style&index=0&id=0f497b99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f497b99",
  null
  
)

export default component.exports